module.exports = __webpack_public_path__ + "img/redstep03.0b0a1dd4.png";